import React from 'react';
import Modal from 'react-modal';
import classNameBind from 'classnames/bind';
import Transition from 'react-transition-group/Transition';
import Header from '../Header';
import Icon from '../Icon';
import styles from './OverlayView.module.css';

const TRANSITION_DURATION = 200;
const bindClasses = classNameBind.bind(styles);
const defaultStyle = {
  transition: `all ${TRANSITION_DURATION}ms ease-in-out`,
  position: 'absolute',
  top: window.innerHeight,
};
const transitionStyles = {
  entering: { top: window.innerHeight },
  entered: { top: 0 },
};
const generateStyles = state => ({
  ...defaultStyle,
  ...transitionStyles[state],
});

const OverlayView = ({
  isOpen,
  children,
  title,
  onClose,
  customCloseButton,
}) => (
  <Modal
    isOpen={isOpen}
    className={bindClasses('modal')}
    closeTimeoutMS={TRANSITION_DURATION}
    overlayClassName={bindClasses('overlay')}
    ariaHideApp={false}
  >
    <Transition in={isOpen} timeout={TRANSITION_DURATION} appear>
      {state => (
        <div
          style={generateStyles(state)}
          className={bindClasses('wrapper')}
          data-ppuc-id="OverlayView"
        >
          <div
            className={bindClasses('header')}
            data-ppuc-id="OverlayView.header"
          >
            <div className={bindClasses('left')}>
              <Header type="large">{title}</Header>
            </div>
            {(onClose || customCloseButton) && (
              <div className={bindClasses('close-button-area')}>
                {onClose && (
                <div
                  className={bindClasses('close-button')}
                  onClick={onClose}
                  tabIndex={0}
                  role="button"
                  data-ppuc-id="OverlayView.close"
                >
                  <Icon name="cross" size="medium" />
                </div>
                )}
                {customCloseButton && (
                <div className={bindClasses('custom-close-button-wrapper')}>
                  {customCloseButton}
                </div>
                )}
              </div>
            )}
          </div>
          <div
            className={bindClasses('content')}
            data-ppuc-id="OverlayView.content"
          >
            {children}
          </div>
        </div>
      )}
    </Transition>
  </Modal>
);

OverlayView.defaultProps = {
  children: null,
  isOpen: false,
  onClose: undefined,
  customCloseButton: undefined,
};

export default OverlayView;
